import {
    FETCH_ONE_PRODUCT_RELATED,
    FETCH_ONE_PRODUCT_RELATED_FAILURE,
    FETCH_ONE_PRODUCT_RELATED_SUCCESS,
} from 'store/actions/types';

export const fetchProductRelated = (payload) => {
    return {
        type: FETCH_ONE_PRODUCT_RELATED,
        payload: payload,
    };
};

export const fetchProductRelatedFailure = (error, productId) => {
    return {
        type: FETCH_ONE_PRODUCT_RELATED_FAILURE,
        productId: productId,
        error: error,
    };
};

export const fetchProductRelatedSuccess = (response, productId) => {
    return {
        type: FETCH_ONE_PRODUCT_RELATED_SUCCESS,
        productId: productId,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/related/fetchProductRelated.js